import { Component, Input, OnInit } from '@angular/core';
import { ITimeTracker, TimeTrackingService } from '../../services/time-tracking.service';
import moment from 'moment';

import { SHARED_MODULES } from '../../../shared.';
import { PhButtonComponent } from '../ph-button/ph-button.component';

@Component({
    selector: 'app-time-tracker[key]',
    templateUrl: './time-tracker.component.html',
	imports: [SHARED_MODULES, PhButtonComponent],
    standalone: true
})
export class TimeTrackerComponent implements OnInit {
	moment = moment;
	timer: ITimeTracker;

	@Input('key') key: string | number;
	@Input('simpleView') simpleView: boolean = false;
	@Input('startCheckCallback') startCheckCallback: Function;

	constructor(private timeTrackingService: TimeTrackingService) {}

	get time(): string {
		return Math.floor(this.timer.time.asHours()) + ':' + moment.utc(this.timer.time.asMilliseconds()).format('mm:ss')
	}

	ngOnInit(): void {
		this.timer = this.timeTrackingService.timers.get(this.key);
	}

	buttonClick(): void {
		if (this.timer.isUpdating) return;
		if (this.timer.running)
			this.timeTrackingService.timerPause(this.key);
		else
			if (!this.timer.time.asMilliseconds())
				this.timerStart();
			else this.timeTrackingService.timerContinue(this.key);
	}

	timerStart(): void {
		if (this.startCheckCallback && !this.timer.time.asMilliseconds())
			this.startCheckCallback().subscribe((value: boolean) => {
				if (value) this.timeTrackingService.startTracking(this.key);
			})
		else this.timeTrackingService.startTracking(this.key);
	}
}
